import React, { useEffect, useState } from 'react'
import { changeStateRepresentativeRequest, getRepresentativeRequestByID } from '../../actions/certificationActions';
import { useDispatch, useSelector } from 'react-redux';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG';
import { EcoMasterIcon } from '../../../assets/icons';

const CertificateRepresentativeRequest = ({ match }) => {
    let idAuthRequest = match.params.idAuthRequest

    const dispatch = useDispatch();

    const [argument, setargument] = useState('')

    useEffect(() => {
        dispatch(getRepresentativeRequestByID(idAuthRequest))
    }, [])

    const { representativeRequest } = useSelector((state) => state.certificationAdmin);

    console.log();
    return (
        <div>
            <TitleSVG Icon={EcoMasterIcon}
                titleHighlight={'Datos'}
                title={' de la solicitud'}
            />
            <div className='wrapper-1 column-gap row-gap mt-5'>
                {

                    <div className="card-admin">
                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Nombre: </span>
                            {representativeRequest?.userID?.name}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Apellido: </span>
                            {representativeRequest?.userID?.lastname}
                        </div>

                      

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Tipo de persona: </span>
                            {representativeRequest?.kindOfPerson}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Correo Empresarial: </span>
                            {representativeRequest?.businessEmail}
                        </div>

                        <div className="text-content-card mt-1">
                            <span className='text-bold color-purple-dark'>Teléfono Empresarial: </span>
                            {representativeRequest?.businessPhone}
                        </div>
                        {(representativeRequest?.kindOfPerson === "juridica" || representativeRequest?.kindOfPerson === "comerciante") &&
                            <>
                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Rut:
                                    </span>
                                    <a target="_blank" href={representativeRequest?.rut?.url?.origin}>Ver soporte</a>
                                </div>

                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Cámara de comercio:
                                    </span>
                                    <a target="_blank" href={representativeRequest?.chamberOfCommerce?.url?.origin}>Ver soporte</a>
                                </div>

                                <div className="text-content-card mt-1">
                                    <span className='text-bold color-purple-dark'>
                                        Certificación bancaria:
                                    </span>
                                    <a target="_blank" href={representativeRequest?.bankCertification?.url?.origin}>Ver soporte</a>
                                </div>

                                {representativeRequest.commercialReference &&
                                    <div className="text-content-card mt-1">
                                        <span className='text-bold color-purple-dark'>
                                            Referencia comercial:
                                        </span>
                                        <a target="_blank" href={representativeRequest?.commercialReference?.url?.origin}>Ver soporte</a>
                                    </div>

                                }
                            </>
                        }

                       

                        <div className='text-bold color-purple-dark mt-2'>Motivo de rechazo</div>
                        <input
                            className='height-100 rounded border-box border-light border-secondary-color mt-1'
                            type="text"
                            id="argument"
                            name="argument"
                            value={argument}
                            onChange={(e) => { setargument(e.target.value) }}
                        />

                        <div className="column centerContent">
                            <div className="btns-admin ml-1 mr-1" onClick={() => { dispatch(changeStateRepresentativeRequest(representativeRequest._id, 2)) }}>Aceptar</div>
                            <div className="btn-red btns-admin ml-1" onClick={() => { dispatch(changeStateRepresentativeRequest(representativeRequest._id, 1, argument)) }}>Rechazar</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CertificateRepresentativeRequest
